import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { LifeInsuranceFormFields } from "web_myplann/Portfolio/Forms/LifeInsuranceForm/LifeInsuranceFormFields";
import { useCreateLifeInsuranceForm } from "web_myplann/Portfolio/Forms/LifeInsuranceForm/useCreateLifeInsuranceForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

export const CreateLifeInsuranceForm = () => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useCreateLifeInsuranceForm();

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.AddShared.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<LifeInsuranceFormFields control={form.control} showContractValues />
		</PortfolioFormShell>
	);
};
